import { COLOR, line } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'OBV',
  version: 2,
  label: 'On-Balance Volume',
  pane: 'sub',
  category: 'volume',
  series: 'volume',
  order: 90,
  inputs: [],
  outputs: [line('obv', 'OBV', COLOR.blue)],
  talib: { functions: ['OBV'], expr: 'OBV(close, volume)' },
  listed: true,
  tailSafe: false,
  lookback: () => 0,
}
export default def
